// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list[data-v-200714f5]{column-gap:2em;display:grid;grid-template-columns:repeat(auto-fit,minmax(10em,max-content))}.list[data-v-200714f5],.with-counts a[data-v-200714f5]{align-items:center;justify-content:space-between}.with-counts a[data-v-200714f5]{display:flex;margin:.25em 0}a span[data-v-200714f5]{color:var(--colour-text-light);font-size:var(--small);margin-left:.75em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
